// Properties of the date object. E.g:
// Sets the fields of the date(year, month, day, hour, minutes, ...)
// Sets the timezone of the date. If none mentioned, no offset will be applied to the user agent's date.
// For example, for the EST timezone offset we could add the 'timeZone: "UTC",' option bellow
export const PARAM_DATE_OPTIONS = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
};

export const USER_FRIENDLY_DATE_OPTIONS = {
	weekday: "short",
	calendar: "numeric",
	month: "long",
	day: "2-digit",
};

export function dateToString(theDate, theDateOptions) {
	// Format of date String.
	const DATE_FORMAT = "en-ZA"; // YYYY/MM/DD from (https://gist.github.com/mlconnor/1887156)

	// return the date in the desired format
	return theDate
		.toLocaleDateString(DATE_FORMAT, theDateOptions)
		.replaceAll("/", "-");
}

// Parses a "YYYY-MM-DD" string into a local-time Date, avoiding the UTC
// off-by-one day `new Date(dateString)` causes in timezones behind UTC.
export function parseIsoDateString(dateString) {
	const [year, month, day] = dateString.split("-").map(Number);
	return new Date(year, month - 1, day);
}

// Inverse of parseIsoDateString: formats a local-time Date back to "YYYY-MM-DD".
export function formatIsoDateString(theDate) {
	const year = theDate.getFullYear();
	const month = String(theDate.getMonth() + 1).padStart(2, "0");
	const day = String(theDate.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}
